import {Box, HStack, Skeleton, SkeletonText} from '@chakra-ui/react';
import React from 'react';

// Skeleton de chargement pour un produit
export const ProductSkeleton = React.memo(() => (
  <Box
    p={4}
    borderBottom='1px solid'
    borderColor='gray.200'
  >
    <HStack
      spacing={4}
      align='flex-start'
    >
      <Skeleton
        height='80px'
        width='80px'
        borderRadius='md'
      />
      <Box flex='1'>
        <SkeletonText
          mt='1'
          noOfLines={1}
          spacing='2'
        />
        <SkeletonText
          mt='3'
          noOfLines={2}
          spacing='2'
          width='70%'
        />
        <HStack
          mt={3}
          spacing={4}
        >
          <Skeleton
            height='20px'
            width='80px'
          />
          <Skeleton
            height='20px'
            width='60px'
          />
        </HStack>
      </Box>
      <Skeleton
        height='35px'
        width='100px'
      />
    </HStack>
  </Box>
));

// Liste de skeleton de produits
export const ProductSkeletonList = React.memo(() => (
  <Box bg='white'>
    {Array(5)
      .fill(0)
      .map((_, i) => (
        <ProductSkeleton key={i} />
      ))}
  </Box>
));
